import { useState, useContext, useEffect, createContext, useRef } from "react"
import { getSession, useSession } from "./session"
import { clientConfig, default_cond_pag } from "../api"

const Context = createContext()

const getUserIdentify = (user_name, client_id) => {
  if (user_name && client_id) {
    return `${user_name} - ${client_id}`
  }
  if (client_id) {
    return client_id
  }
  return "-"
}

export const UserProvider = ({ children }) => {
  let mounted = useRef(true)
  const [user, setUser] = useState({
    client_id: "",
    user_id: "",
    user_name: "",
    user_identify: "",
    cond_pag: default_cond_pag,
  })
  const { hasSession } = useSession()

  useEffect(async () => {
    if (!hasSession || !mounted) {
      return null
    }
    console.log("initializing user provider")
    const { user_id, user_name, client_id } = getSession()
    const user_identify = getUserIdentify(user_name, client_id)
    const { company, cond_pag, grade_enabled, parapar_enabled, surfacado_enabled } =
      await clientConfig()
    setUser({
      ...user,
      client_id,
      user_id,
      user_name,
      user_identify,
      cond_pag,
      company,
      grade_enabled,
      parapar_enabled,
      surfacado_enabled,
    })
    return () => {
      mounted = false
    }
  }, [hasSession])

  return <Context.Provider value={{ user }}>{children}</Context.Provider>
}

export const useUser = () => useContext(Context)
